import { AppState } from 'mk2/reducers';
import { ContestsHomePageState, initialContestsHomePageState } from './ContestsHome.reducers';

export const getContestsHomePageState = (state: AppState): ContestsHomePageState =>
    state.containers.contests.home || initialContestsHomePageState;
